import { ServiceBase } from './serviceBase';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class ApplicationService extends ServiceBase {


    getLatestVersion(): Observable<string> {

        const headers = this.getHeaders();

        return this.httpClient.get<any>(environment.apiVersionUrl)
            .pipe(
                map(v => v.version)
            );

    }

}

